<template>
  <div class='home'>
    <BankList
      v-show='listView'
      @newBank='onClickNewFromList'
      @editBank='onClickEditFromList'
      :scroll="corY" ref='refreshList'
    />
    <BankForm
      v-show='formView'
      :bank='bank'
      @backClicked='onBackChild'
    />
  </div>
</template>

<script>
// @ is an alias to /src
import BankList from '@/components/bank/BankList.vue'
import BankForm from '@/components/bank/BankForm.vue'

export default {
  name: 'Bank',
  components: {
    BankList,
    BankForm
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      bank: {
        id: null,
        group_id: null,
        account_no: null,
        name: null,
        address: null,
        phone: null,
        email: null,
        account_code: null
      }
    }
  },
  methods: {
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.bank = value
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.bank = {
        id: null,
        bank_no: null,
        org_id: null,
        name: null,
        address: null,
        phone: null,
        email: null,
        account_code: null
      }
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.bank = {
        id: null,
        bank_no: null,
        org_id: null,
        name: null,
        address: null,
        phone: null,
        email: null,
        account_code: null
      }
      await this.$refs.refreshList.refreshList()
      await window.scrollTo(this.corX, this.corY)
      console.log('window.scrollTo:' + this.corY)
    }
  },
  mounted () {
    this.$store.dispatch('getAccountList')
    this.$store.dispatch('getBankGroupList')
    this.$store.dispatch('getCompanyList')
  }
}
</script>
